import { createEvent, sample } from 'effector'
import { MenuItem } from 'react-aria-components'

import { css, cx } from '@portal/styled-system/css'

import { LangDialog } from '@/features/lang-selector'
import { LANG_SELECTOR_ENABLE } from '@/shared/config/env'
import { useI18n } from '@/shared/lib/i18n'

import { NavbarItem } from '../navbar-item/view'
import { navbarMenu } from '../styles/recipe'
import type { NavbarItemVariant } from '../types'

const langButtonClicked = createEvent<any>()
sample({
    clock: langButtonClicked,
    target: LangDialog.model.showFx,
})

export function LangButton({ variant = 'default' }: { variant?: NavbarItemVariant }) {
    const { i18n, lang } = useI18n()
    const classes = navbarMenu()

    if (!LANG_SELECTOR_ENABLE) {
        return null
    }

    if (variant === 'dropdown') {
        return (
            <MenuItem onAction={langButtonClicked} className={classes.itemNav}>
                <i className={cx('fa-light fa-globe', classes.icon)} />
                &nbsp;{i18n[`lang_${lang}`]}
            </MenuItem>
        )
    }

    return (
        <NavbarItem navbarItemType="button" onClick={langButtonClicked}>
            <i className={cx('fa-light fa-globe', css({ color: 'info' }))} />
            &nbsp;{i18n[`lang_${lang}`]}
        </NavbarItem>
    )
}
